import React from "react";
import * as Styled from "./Style";
import * as GlobalStyle from "../../CSSStyles";
import arrowNorthEast from "../../assets/images/icons/ic_arrow_northeast.svg";

const CheckoutSummary = (props) => {
  return (
    <Styled.CheckoutSummaryStyle className={props.className}>
      <div className="summary-title sub-section-title">Your Order</div>
      <div className="summary-amounts">
        <div className="detail">
          <div className="title">Subtotal</div>
          <div className="value">
            {props.data.bagLoader || props.data.confirmApiLoader ?'Loading...':
              props.totalLabel
              ? props.subTotal
              : props.currency + "" + props.subTotal}
          </div>
        </div>
        {props.shippingPrice ? (
          <div className="detail">
            <div className="title">{props.deliveryLabel}</div>
            <div className="value">{props.data.bagLoader || props.data.confirmApiLoader ?'Loading...':props.shippingPrice}</div>
          </div>
        ) : (
          <div className="detail">
            <div className="title">Delivery</div>
            <div className="value">{props.data.bagLoader || props.data.confirmApiLoader ?'Loading...':'-'}</div>
          </div>
        )}
      </div>

      {props.data.bagLoader || props.data.confirmApiLoader ?'':
      parseFloat(props.orderDiscountTotal) > 0 ? (
        <div className="summary-amounts">
          <div className="detail">
            <div className="title">Promotional Code</div>
            <div
              className="value"
              style={{
                color: "#115b05",
              }}
            >
              {props.currency + "" + props.orderDiscountTotal}
            </div>
          </div>
        </div>
      ) : (
        ""
      )
    }

      {props.data.bagLoader || props.data.confirmApiLoader ?
        <div className="summary-total">
          <div className="total-detail">
            <div className="total-title subsub-section-title">Total</div>
            <div className="total-value subsub-section-title">Loading...</div>
          </div>
        </div>
      :
      <>
      {!props.totalLabel == "" ? (
        <div className="summary-total">
          <div className="total-detail">
            <div className="total-title subsub-section-title">
              {props.totalLabel}
              {parseInt(props.confirmPreorder) > 0 &&
              parseInt(props.chargeNow) > 0
                ? "*"
                : ""}
            </div>
            <div className="total-value subsub-section-title">
              {props.total}
            </div>
          </div>
          <div className="total-detail">
            <div className="total-value vat">{props.vat}</div>
          </div>
        </div>
      ) : (
        <div className="summary-total">
          <div className="total-detail">
            <div className="total-title subsub-section-title">Total</div>
            <div className="total-value subsub-section-title">
              {props.currency}
              {props.total}
            </div>
          </div>
        </div>
      )}
      {parseInt(props.confirmPreorder) > 0 && parseInt(props.chargeNow) > 0 ? (
        <div className="summary-preorder">
          <div className="detail">
            <div className="title">Charge now</div>
            <div className="value">
              {props.currency}
              {props.chargeNow}
            </div>
          </div>
        </div>
      ) : null}
      {parseInt(props.confirmPreorder) > 0 && parseInt(props.chargeNow) > 0 ? (
        <div className="summary-chargenow-message">
          <div className="detail">
            <div className="title">
              {parseInt(props.confirmAvailable) > 0 ? (
                <span>*You will be charged when the item is despatched.</span>
              ) : (
                <span>*You will only be charged for delivery and tax now.</span>
              )}
            </div>
            <div className="value"></div>
          </div>
        </div>
      ) : null}
      </>}
      { (props.hidePromoFieldOrderDetails && props.hidePromoFieldOrderDetails == 'show')
        || (!props.hidePromoFieldOrderDetails && props.hidePromoFieldBag && props.hidePromoFieldBag == 'show')
        ? 
        <div className="summary-promo">
          {props.className == "mobile-checkout-summary" ? (
            <input
              type="checkbox"
              id="togglePromoCode"
              className="toggle-promo-code"
            />
          ) : (
            ""
          )}
          <label
            className="summary-section-title subsub-section-title"
            htmlFor="togglePromoCode"
          >
            Apply a Promo code
            {props.data.chosenDeliveryAddress.id && props.data.chosenBillingAddress.id ? (
              ""
            ) : (
              <span className="promo-note">
                <br />
                Please add delivery and billing address to enable promo code
              </span>
            )}
          </label>
          <div className="promo-form">
            <input
              id={props.type + "_promoCode"}
              className={
                (props.promoCodeConfirm ? "with-value" : "") +
                " " +
                (props.shippingPrice ? "" : "disabled")
              }
              disabled={props.shippingPrice ? false : true}
              type="text"
              placeholder={
                props.promoCodeConfirm || props.bagDiscountCode || "Promo code"
              }
              onChange={props.updatePromoInput}
              onKeyUp={(e) => {
                if (
                  e.key === "Enter" &&
                  props.shippingPrice &&
                  props.promoInputValue &&
                  props.promoInputValue.toUpperCase() !=
                    props.promoCodeConfirm.toUpperCase()
                ) {
                  props.applyPromo(e);
                }
              }}
              value={props.promoInputValue}
              onFocus={props.promoCodeInputFocus}
              onBlur={props.promoCodeInputBlur}
              autoComplete="off"
            />
            <label htmlFor={props.type + "_promoCode"} className="hidden">
              Enter Promo Code
            </label>
            {props.shippingPrice &&
            props.promoInputValue &&
            props.promoInputValue.toUpperCase() !=
              props.promoCodeConfirm.toUpperCase() ? (
              <button type="button" onClick={props.applyPromo} className="">
                Apply
              </button>
            ) : (
              <button type="button" className="disabled">
                &nbsp;Apply
              </button>
            )}
          </div>
          {props.promoCodeInputEntered ? (
            props.promoCodeConfirmInput ? (
              props.promoCodeMessage ? (
                <Styled.PromoMessageStyle
                  className={
                    props.promoClassName == "success" ? "success" : "error"
                  }
                >
                  <span className="promo-icon"></span>
                  {props.promoCodeConfirmInput + " " + props.promoCodeLabel}
                </Styled.PromoMessageStyle>
              ) : (
                ""
              )
            ) : (
              ""
            )
          ) : (
            ""
          )}
  
          {props.promoCodeConfirm && props.isPromoCodeInputFocus ? (
            <Styled.CheckoutSummaryWarningNote>
              <p>
                Entering a new valid promo code will overwrite your existing one.
              </p>
            </Styled.CheckoutSummaryWarningNote>
          ) : (
            ""
          )}
        </div> : ''}
      <div className="summary-terms">
        <span>
          By placing your order you agree to our
          <br />
          <a href="/about-us/legal-notices/conditions-sale" target="_blank">
            Terms and Conditions
          </a>{" "}
          and{" "}
          <a href="/about-us/legal-notices/privacy-notice" target="_blank">
            Privacy Notice
          </a>
        </span>
        {props.unavailableCount > 0 &&
        (props.availableCount > 0 ||
          props.preorderCount > 0 ||
          props.partialCount > 0) ? (
          <Styled.CheckoutSummaryWarningNote>
            <p>
              You have unavailable items in your bag. Please remove items to
              continue to payment.
            </p>
          </Styled.CheckoutSummaryWarningNote>
        ) : (
          ""
        )}
      </div>
      <div className="summary-proceed">
        <GlobalStyle.MainBtnStyle
          className={!props.isContinuePaymentValid ? "btn-disabled" : ""}
          onClick={
            props.isContinuePaymentValid ? props.continueToPayment : null
          }
        >
          <span className="btn-txt">Continue to Payment</span>
        </GlobalStyle.MainBtnStyle>
      </div>
      <div className="summary-notes">
        <span>
          <span className="highlight">
            We'll take your card details on the next page.
          </span>{" "}
          You'll be redirected to our trusted payment partner <br />
          Cybersource to complete your purchase securely
        </span>
      </div>
      <div className="shopping-help">
        <a href="/shopping-help" target="_blank">
          Shopping help <img src={`${arrowNorthEast}`} alt="" />
        </a>
      </div>
    </Styled.CheckoutSummaryStyle>
  );
};

export default CheckoutSummary;
